import { createFileRoute, Link } from "@tanstack/react-router";
import { CITIES, BUSINESS } from "@/lib/site-data";

export const Route = createFileRoute("/service-areas")({
  head: () => ({
    meta: [
      { title: "Service Areas — Trades SEO across Utah County" },
      {
        name: "description",
        content:
          "We help trades contractors rank in Lehi, American Fork, Saratoga Springs, Pleasant Grove, Eagle Mountain, Orem, and Provo. Local SEO and Google Ads, on the ground in Utah.",
      },
      { property: "og:title", content: "Service Areas — Utah County Trades SEO" },
      {
        property: "og:description",
        content: "Local SEO and Google Ads for trades contractors across Utah County cities.",
      },
      { property: "og:url", content: "/service-areas" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/service-areas" }],
  }),
  component: AreasIndex,
});

function AreasIndex() {
  return (
    <main className="mx-auto max-w-6xl px-6 py-20">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
        Where our clients rank
      </p>
      <h1 className="mt-4 font-display text-5xl tracking-tight md:text-6xl">
        Utah County trades SEO coverage
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
        {BUSINESS.name} is based in {BUSINESS.address.locality},{" "}
        {BUSINESS.address.region} and works with trades contractors across
        Utah County and the south end of Salt Lake County.
      </p>
      <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CITIES.map((c) => (
          <li key={c.slug}>
            <Link
              to="/service-areas/$city"
              params={{ city: c.slug }}
              className="block rounded-2xl border border-border bg-card p-6 transition hover:border-primary/40 hover:shadow-sm"
            >
              <div className="font-display text-2xl tracking-tight">
                {c.name}, {c.region}
              </div>
              <p className="mt-2 text-sm text-muted-foreground">{c.blurb}</p>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
}